import { render, staticRenderFns } from "./SelectEncyclopedia.vue?vue&type=template&id=609e9a9b&scoped=true"
import script from "./SelectEncyclopedia.vue?vue&type=script&lang=js"
export * from "./SelectEncyclopedia.vue?vue&type=script&lang=js"
import style0 from "./SelectEncyclopedia.vue?vue&type=style&index=0&id=609e9a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e9a9b",
  null
  
)

export default component.exports